module.exports = __webpack_public_path__ + "static/media/layer-group.b6be7baa.svg";